import React, { type FC } from "react";
import { MAIN_NAV_CLASSNAME_TOYOTA } from "../../../../../../../common-deprecated/constants";
import UnsetZIndexHelper from "../../../../../../../common-deprecated/components/UnsetZIndexHelper";
import ModalBaseView from "../../../../../../../common-deprecated/components/modals/aem/ModalBaseView";
import * as Modal from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Modal";
import { IconWrapper } from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";

import { MODAL_TRADE_IN_WRAPPER } from "../../../../../../../shared-logic/features/tradein/utils/modalConstants";

type Props = { show: boolean; children: React.ReactElement; closeModal: () => void };

/**
 * Wrapper modal for trade-in integrated.
 * Used in the IntegratedTradeInAemModal component.
 * !! Keep in mind that this component has a duplicate for the standalone. !!
 * src/tradein/components/toyota/common/TradeInAemModalWrapper.tsx
 */
const TradeInAemModalWrapper: FC<Props> = ({ show, children, closeModal }) => {
    return (
        <div>
            <UnsetZIndexHelper enabled selectors={[MAIN_NAV_CLASSNAME_TOYOTA, ".fluid.scroll"]} />
            <ModalBaseView
                modalIdType={MODAL_TRADE_IN_WRAPPER}
                show={show}
                onClose={closeModal}
                size="xl"
                disableOutsideClick
            >
                <Modal.Header>
                    <Modal.Button onClick={closeModal}>
                        <IconWrapper>
                            <Icon variant="close" />
                        </IconWrapper>
                    </Modal.Button>
                </Modal.Header>
                <Modal.Body>{children}</Modal.Body>
            </ModalBaseView>
        </div>
    );
};

export default TradeInAemModalWrapper;
